
import React, { useCallback } from 'react';
import { Input } from '@/components/ui/input';
import { VideoFilterOptions } from '@/hooks/useVideoEvents';

interface SearchInputProps {
  filterOptions: VideoFilterOptions;
  onFilterChange: (filters: VideoFilterOptions) => void;
}

const SearchInput: React.FC<SearchInputProps> = ({
  filterOptions,
  onFilterChange,
}) => {
  const handleInputChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const newOptions = { 
      ...filterOptions, 
      title: e.target.value 
    };
    onFilterChange(newOptions);
  }, [filterOptions, onFilterChange]);

  return (
    <Input
      value={filterOptions.title || ''}
      onChange={handleInputChange}
      placeholder="Rechercher par titre"
      className="w-full md:w-80 font-sans border-gray-300 dark:border-gray-700 focus:border-custom-primary dark:focus:border-custom-secondaryLight"
    />
  );
};

export default SearchInput;
